import React from "react";
import { Link } from "react-router-dom";

const NavButton = ({ to, btnName, className = "", selectState = false }) => {
  return (
    <Link
      to={to}
      className={`border bg-main-white ${
        selectState
          ? "border-main-blue text-main-blue  font-medium"
          : " border-main-border text-main-subfont  font-normal"
      }  hover:text-main-blue hover:border-main-blue group relative inline-flex h-10 items-center justify-center overflow-hidden rounded-lg px-6 transition  hover:scale-105 ${className}`}
      aria-label={btnName}
    >
      <span className="relative">{btnName}</span>
    </Link>
  );
};

export default NavButton;
